import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingStatus } from '../../redux/types';
import { initSignupFlow } from '../../redux/auth/authThunk';
import {
  initLanguages,
  setInitialLanguage,
} from '../../redux/localization/localizationThunk';
import { Loader } from '../common/Loader';
import { getRegistrationLoadingError } from '../../redux/common/commonSelectors';
import { getLoadingStatus } from '../../redux/auth/authSelectors';
import { DriverSignupMinimal } from './DriverSignupMinimal';
import { autosaveFailed } from '../../redux/autosave/autosaveActions';
import { getTranslations } from '../../redux/form/formSelectors';

export const DriverSignupMinimalLayout: React.FC = () => {
  const dispatch = useDispatch();
  const t = useSelector(getTranslations);
  const loadingStatus = useSelector(getLoadingStatus);
  const loadingErrorMessage =
    useSelector(getRegistrationLoadingError) ??
    t.common_errors.failed_to_load_registration;
  React.useEffect(() => {
    dispatch(autosaveFailed());
    dispatch(setInitialLanguage());
    dispatch(initSignupFlow());
  }, [dispatch]);

  React.useEffect(() => {
    if (loadingStatus === LoadingStatus.FAILED) {
      dispatch(initLanguages());
    }
  }, [dispatch, loadingStatus]);

  return (
    <>
      {loadingStatus === LoadingStatus.READY && <DriverSignupMinimal />}
      {loadingStatus === LoadingStatus.LOADING && (
        <div className="clearfix pt-6">
          <div className="flex flex-row justify-center my-8 h-24">
            <Loader
              data-test="app_form_loader"
              textColor="text-green-500"
              id="document_upload_example_loader"
            />
          </div>
        </div>
      )}
      {loadingStatus === LoadingStatus.FAILED && (
        <div>
          <div className="ml-2 mt-4 font-semibold text-2xl">
            {t.common_errors.unknown_error}
          </div>
          <div className="ml-2 mt-4 text-gray-700">
            {loadingErrorMessage} <br />
            {t.common_errors.something_went_wrong}
          </div>
        </div>
      )}
    </>
  );
};
